import React from 'react';
import { Check, ShieldCheck, Brain, Heart, Users, Lightbulb, Lock } from 'lucide-react';
import { CTAButton } from '../components/CTAButton';
import { PurchaseNotification } from '../components/PurchaseNotification';
import { TestimonialCard } from '../components/TestimonialCard';
import { BonusCard } from '../components/BonusCard';
import { MetaphorPreview } from '../components/MetaphorPreview';
import { trackAddToCart } from '../utils/metaPixel';
export function LandingPage() {
  const scrollToPurchase = () => {
    const purchaseSection = document.getElementById('purchase-section');
    if (purchaseSection) {
      purchaseSection.scrollIntoView({
        behavior: 'smooth'
      });
    }
  };
  const handleDownloadClick = () => {
    // Track AddToCart event
    trackAddToCart();
    // Redirect to checkout
    window.open('https://checkout.recursospro.shop/cart/46826677338368:1', '_blank');
  };
  const testimonials = [{
    name: 'Lic. Ana María González',
    role: 'Psicóloga Clínica (UBA)',
    location: 'Buenos Aires',
    content: 'Increíble cómo una metáfora bien puesta puede desbloquear sesiones de meses. Este kit me dio el vocabulario simbólico que me faltaba. Mis pacientes conectan mucho más rápido con sus emociones.'
  }, {
    name: 'Dr. Roberto Méndez',
    role: 'Psiquiatra y Psicoterapeuta',
    location: 'Córdoba',
    content: 'Lo uso diariamente. No es solo un banco de historias, es una estructura clínica. Me ayuda a explicar conceptos complejos de forma simple. La resistencia baja notablemente.'
  }, {
    name: 'Lic. Sofía Roldán',
    role: 'Terapia Sistémica',
    location: 'Rosario',
    content: 'La sección de ansiedad y duelo es oro puro. Las ilustraciones ayudan a externalizar el problema. Es una inversión que recuperé en la primera semana de uso.'
  }, {
    name: 'Lic. Martín Varela',
    role: 'Psicólogo Cognitivo-Conductual',
    location: 'Mendoza',
    content: 'Al principio dudé, pero la calidad del material es excelente. Me ahorra horas de planificación. Cuando no sé por dónde entrarle a un tema, el índice por problemáticas me salva.'
  }, {
    name: 'Lic. Laura Echeverría',
    role: 'Psicóloga Infantil y Adolescentes',
    location: 'La Plata',
    content: 'Los adolescentes suelen ser difíciles de abrir. Con estas metáforas visuales logré que chicos que no hablaban empezaran a contarme su mundo interno. Fundamental.'
  }];
  return <div className="min-h-screen bg-slate-50 font-sans text-slate-900 selection:bg-teal-100 selection:text-teal-900" data-id="element-36">
      {/* Meta Pixel noscript fallback */}
      <noscript data-id="element-37">
        <img height="1" width="1" style={{
        display: 'none'
      }} src="https://www.facebook.com/tr?id=1170774765082882&ev=PageView&noscript=1" alt="" data-id="element-38" />
      </noscript>

      <PurchaseNotification data-id="element-39" />

      {/* Hero Section */}
      <header className="bg-gradient-to-b from-teal-900 to-slate-900 text-white pt-12 pb-20 px-4 overflow-hidden relative" data-id="element-40">
        <div className="absolute top-0 left-0 w-full h-full overflow-hidden opacity-10 pointer-events-none" data-id="element-41">
          <div className="absolute -top-24 -right-24 w-96 h-96 rounded-full bg-teal-400 blur-3xl" data-id="element-42"></div>
          <div className="absolute top-1/2 -left-24 w-72 h-72 rounded-full bg-amber-400 blur-3xl" data-id="element-43"></div>
        </div>

        <div className="max-w-6xl mx-auto relative z-10" data-id="element-44">
          <div className="flex flex-col md:flex-row items-center gap-12" data-id="element-45">
            <div className="flex-1 text-center md:text-left" data-id="element-46">
              <div className="inline-block px-4 py-1.5 rounded-full bg-teal-800/50 border border-teal-500/30 text-teal-300 text-sm font-semibold mb-6 backdrop-blur-sm" data-id="element-47">
                RECURSO EXCLUSIVO PARA PROFESIONALES
              </div>
              <h1 className="text-4xl md:text-5xl lg:text-6xl font-extrabold tracking-tight leading-tight mb-6" data-id="element-48">
                INTERVENCIÓN EMOCIONAL CON{' '}
                <span className="text-transparent bg-clip-text bg-gradient-to-r from-teal-200 to-teal-400" data-id="element-49">
                  METÁFORAS TERAPÉUTICAS
                </span>
              </h1>
              <p className="text-xl md:text-2xl text-slate-300 mb-8 font-light leading-relaxed" data-id="element-50">
                Herramienta clínica para generar insight, reestructuración
                cognitiva y quiebres terapéuticos reales.
              </p>
              <div className="flex flex-col sm:flex-row gap-4 justify-center md:justify-start" data-id="element-51">
                <CTAButton variant="secondary" data-id="element-52">ACCESO INMEDIATO</CTAButton>
                <button onClick={() => document.getElementById('problem-section')?.scrollIntoView({
                behavior: 'smooth'
              })} className="px-8 py-4 rounded-lg font-medium text-slate-300 hover:text-white transition-colors flex items-center justify-center gap-2" data-id="element-53">
                  Saber más <span className="text-xl" data-id="element-54">↓</span>
                </button>
              </div>
            </div>
            <div className="flex-1 w-full max-w-md md:max-w-full" data-id="element-55">
              <div onClick={scrollToPurchase} className="relative group cursor-pointer transform transition-transform duration-500 hover:scale-[1.02]" data-id="element-56">
                <div className="absolute -inset-1 bg-gradient-to-r from-teal-500 to-amber-500 rounded-2xl blur opacity-30 group-hover:opacity-60 transition duration-1000 group-hover:duration-200" data-id="element-57"></div>
                <img src="https://cdn.magicpatterns.com/uploads/viJWZb6fMPSRERJ9jW9ZmA/EzYmrq0340435.webp" alt="Kit Terapéutico Esencial - 1500 Metáforas Ilustradas" className="relative rounded-xl shadow-2xl w-full object-cover border border-slate-700/50" data-id="element-58" />
              </div>
            </div>
          </div>
        </div>
      </header>

      {/* The Insight Section */}
      <section className="py-20 px-4 bg-white" data-id="element-59">
        <div className="max-w-3xl mx-auto text-center" data-id="element-60">
          <p className="text-2xl md:text-3xl font-serif italic text-slate-700 leading-relaxed mb-8" data-id="element-61">
            "Hay un punto en cada proceso terapéutico donde la palabra adecuada
            produce más efecto que diez explicaciones."
          </p>
          <div className="w-24 h-1 bg-teal-500 mx-auto mb-8 rounded-full" data-id="element-62"></div>
          <p className="text-lg text-slate-600 leading-relaxed mb-6" data-id="element-63">
            Un momento donde el paciente comprende, no desde la lógica, sino
            desde la vivencia interna.
          </p>
          <p className="text-xl font-bold text-slate-900 mb-6" data-id="element-64">
            Ese punto es el insight.
          </p>
          <p className="text-lg text-slate-600 leading-relaxed" data-id="element-65">
            Y ese punto no se alcanza con teoría. Se alcanza con{' '}
            <span className="font-semibold text-teal-700" data-id="element-66">
              lenguaje simbólico aplicado
            </span>
            .
          </p>
        </div>
      </section>

      {/* Problem Section */}
      <section id="problem-section" className="py-20 px-4 bg-slate-100" data-id="element-67">
        <div className="max-w-4xl mx-auto" data-id="element-68">
          <div className="bg-white rounded-2xl shadow-xl p-8 md:p-12 border border-slate-200" data-id="element-69">
            <h2 className="text-3xl font-bold text-slate-900 mb-8 flex items-center gap-3" data-id="element-70">
              <span className="bg-red-100 text-red-600 p-2 rounded-lg" data-id="element-71">
                <ShieldCheck className="h-8 w-8" data-id="element-72" />
              </span>
              El problema clínico real
            </h2>

            <p className="text-lg text-slate-700 mb-6" data-id="element-73">
              La mayoría de los profesionales cuenta con formación, técnicas y
              marcos conceptuales sólidos.
            </p>

            <p className="text-lg text-slate-700 mb-8 font-medium" data-id="element-74">
              Sin embargo, en la práctica diaria aparece un límite:
            </p>

            <ul className="space-y-4 mb-10" data-id="element-75">
              {['Sesiones que contienen pero no reestructuran', 'Comprensión racional sin cambio conductual', 'Repetición de patrones', 'Resistencia inconsciente', 'Saturación emocional del profesional'].map((item, i) => <li key={i} className="flex items-start gap-3" data-id="element-76">
                  <div className="mt-1 min-w-[20px] h-5 rounded-full bg-red-100 flex items-center justify-center" data-id="element-77">
                    <div className="w-2 h-2 rounded-full bg-red-500" data-id="element-78"></div>
                  </div>
                  <span className="text-slate-700 text-lg" data-id="element-79">{item}</span>
                </li>)}
            </ul>

            <div className="bg-teal-50 border-l-4 border-teal-500 p-6 rounded-r-lg" data-id="element-80">
              <p className="text-xl font-medium text-teal-900" data-id="element-81">
                No es falta de técnica. Es falta de un dispositivo de
                intervención simbólica sistematizado.
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* Solution Section */}
      <section className="py-20 px-4 bg-teal-900 text-white relative overflow-hidden" data-id="element-82">
        <div className="absolute inset-0 bg-[url('https://www.transparenttextures.com/patterns/cubes.png')] opacity-10" data-id="element-83"></div>

        <div className="max-w-5xl mx-auto relative z-10" data-id="element-84">
          <div className="text-center mb-16" data-id="element-85">
            <span className="text-amber-400 font-bold tracking-wider uppercase text-sm mb-2 block" data-id="element-86">
              Presentamos
            </span>
            <h2 className="text-4xl md:text-5xl font-bold mb-6" data-id="element-87">
              KIT TERAPÉUTICO ESENCIAL
            </h2>
            <p className="text-xl text-teal-100 max-w-3xl mx-auto" data-id="element-88">
              Sistema clínico de metáforas terapéuticas estructuradas para
              intervención emocional directa.
            </p>
          </div>

          <div className="grid md:grid-cols-2 gap-12 items-center" data-id="element-89">
            <div data-id="element-90">
              <p className="text-lg text-teal-50 mb-8 leading-relaxed" data-id="element-91">
                Un recurso profesional que permite acceder al inconsciente,
                reducir resistencias y generar insight clínicamente
                significativo.
              </p>

              <h3 className="text-2xl font-bold text-white mb-6 border-b border-teal-700 pb-2 inline-block" data-id="element-92">
                ¿Qué incluye?
              </h3>

              <ul className="space-y-4 mb-8" data-id="element-93">
                {['Más de 1500 metáforas terapéuticas ilustradas', 'Clasificadas por problemática clínica', 'Diseñadas para sesiones presenciales u online', 'Aplicables a cualquier enfoque terapéutico', 'Uso inmediato'].map((item, i) => <li key={i} className="flex items-center gap-3" data-id="element-94">
                    <Check className="h-6 w-6 text-amber-400 flex-shrink-0" data-id="element-95" />
                    <span className="text-lg text-teal-50" data-id="element-96">{item}</span>
                  </li>)}
              </ul>

              <CTAButton variant="secondary" className="w-full md:w-auto" data-id="element-97">
                QUIERO ACCEDER AHORA
              </CTAButton>
            </div>

            <div className="relative" data-id="element-98">
              <div className="absolute inset-0 bg-teal-500 rounded-full blur-3xl opacity-20" data-id="element-99"></div>
              <img src="https://cdn.magicpatterns.com/uploads/viJWZb6fMPSRERJ9jW9ZmA/EzYmrq0340435.webp" alt="Kit Terapéutico" className="relative rounded-xl shadow-2xl border-4 border-teal-800/50 transform rotate-2 hover:rotate-0 transition-transform duration-500 cursor-pointer" onClick={scrollToPurchase} data-id="element-100" />
            </div>
          </div>
        </div>
      </section>

      {/* Metaphor Preview Section */}
      <section className="py-20 px-4 bg-gradient-to-b from-slate-50 to-white overflow-hidden" data-id="element-101">
        <div className="max-w-7xl mx-auto" data-id="element-102">
          <div className="text-center mb-16" data-id="element-103">
            <span className="inline-block px-4 py-1.5 rounded-full bg-teal-100 text-teal-700 text-sm font-bold mb-4 uppercase tracking-wide" data-id="element-104">
              Vista Previa del Contenido
            </span>
            <h2 className="text-3xl md:text-4xl font-bold text-slate-900 mb-4" data-id="element-105">
              Ejemplos de Metáforas Terapéuticas
            </h2>
            <p className="text-lg text-slate-600 max-w-3xl mx-auto" data-id="element-106">
              Cada metáfora incluye ilustración, narrativa completa, aplicación
              terapéutica y ejercicio práctico para el paciente.
            </p>
          </div>

          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-5 gap-6 mb-12" data-id="element-107">
            <MetaphorPreview image="https://cdn.magicpatterns.com/uploads/icByc5ZpGV7hwWB6sKb4aH/HtiAXu1151389.webp" data-id="element-108" />
            <MetaphorPreview image="https://cdn.magicpatterns.com/uploads/pjvNrq2hnUk2gtSNvvJi22/JfWDCY1128037.webp" data-id="element-109" />
            <MetaphorPreview image="https://cdn.magicpatterns.com/uploads/4ZT3p5oSi3R6LHzgxMHeDj/dfGYsX0815039.webp" data-id="element-110" />
            <MetaphorPreview image="https://cdn.magicpatterns.com/uploads/58zPfCesakoJsdCAS3gsoZ/DfqGIv1108828.webp" data-id="element-111" />
            <MetaphorPreview image="https://cdn.magicpatterns.com/uploads/3uCq5ZHpEPXfuyNY7QSDmc/gdsCed1045337.webp" data-id="element-112" />
          </div>

          <div className="text-center" data-id="element-113">
            <p className="text-slate-600 mb-6 text-lg" data-id="element-114">
              <span className="font-bold text-teal-700" data-id="element-115">
                +1495 metáforas más
              </span>{' '}
              esperándote en el kit completo
            </p>
            <CTAButton variant="primary" data-id="element-116">VER TODO EL CONTENIDO</CTAButton>
          </div>
        </div>
      </section>

      {/* Areas of Intervention */}
      <section className="py-20 px-4 bg-white" data-id="element-117">
        <div className="max-w-6xl mx-auto" data-id="element-118">
          <h2 className="text-3xl font-bold text-center text-slate-900 mb-16" data-id="element-119">
            Áreas de intervención
          </h2>

          <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-5 gap-4 md:gap-6" data-id="element-120">
            {[{
            name: 'Ansiedad',
            icon: Brain
          }, {
            name: 'Duelo',
            icon: Heart
          }, {
            name: 'Autoestima',
            icon: ShieldCheck
          }, {
            name: 'Vínculos',
            icon: Users
          }, {
            name: 'Culpa',
            icon: Lock
          }, {
            name: 'Miedo',
            icon: ShieldCheck
          }, {
            name: 'Trauma',
            icon: Brain
          }, {
            name: 'Decisiones',
            icon: Lightbulb
          }, {
            name: 'Identidad',
            icon: Users
          }].map((area, i) => <div key={i} className="bg-slate-50 p-6 rounded-xl text-center hover:bg-teal-50 hover:shadow-md transition-all duration-300 border border-slate-100 group" data-id="element-121">
                <area.icon className="h-10 w-10 mx-auto mb-3 text-teal-600 group-hover:scale-110 transition-transform" data-id="element-122" />
                <h3 className="font-semibold text-slate-800" data-id="element-123">{area.name}</h3>
              </div>)}
          </div>
        </div>
      </section>

      {/* Results Section */}
      <section className="py-20 px-4 bg-slate-50" data-id="element-124">
        <div className="max-w-5xl mx-auto" data-id="element-125">
          <h2 className="text-3xl font-bold text-center text-slate-900 mb-16" data-id="element-126">
            Resultados observables
          </h2>

          <div className="grid md:grid-cols-2 gap-8" data-id="element-127">
            <div className="bg-white p-8 rounded-2xl shadow-lg border-t-4 border-teal-500" data-id="element-128">
              <h3 className="text-xl font-bold text-teal-800 mb-6 flex items-center gap-2" data-id="element-129">
                <Users className="h-6 w-6" data-id="element-130" /> En el paciente:
              </h3>
              <ul className="space-y-4" data-id="element-131">
                {['Insight más rápido', 'Menor resistencia', 'Mayor conexión emocional', 'Procesamiento profundo', 'Cambio conductual más estable'].map((item, i) => <li key={i} className="flex items-start gap-3" data-id="element-132">
                    <Check className="h-5 w-5 text-teal-500 mt-0.5 flex-shrink-0" data-id="element-133" />
                    <span className="text-slate-700" data-id="element-134">{item}</span>
                  </li>)}
              </ul>
            </div>

            <div className="bg-white p-8 rounded-2xl shadow-lg border-t-4 border-amber-500" data-id="element-135">
              <h3 className="text-xl font-bold text-amber-700 mb-6 flex items-center gap-2" data-id="element-136">
                <ShieldCheck className="h-6 w-6" data-id="element-137" /> En el profesional:
              </h3>
              <ul className="space-y-4" data-id="element-138">
                {['Mayor seguridad', 'Menor carga cognitiva', 'Intervención más precisa', 'Sesiones más eficientes', 'Menor desgaste emocional'].map((item, i) => <li key={i} className="flex items-start gap-3" data-id="element-139">
                    <Check className="h-5 w-5 text-amber-500 mt-0.5 flex-shrink-0" data-id="element-140" />
                    <span className="text-slate-700" data-id="element-141">{item}</span>
                  </li>)}
              </ul>
            </div>
          </div>
        </div>
      </section>

      {/* Foundation Section */}
      <section className="py-20 px-4 bg-teal-800 text-white" data-id="element-142">
        <div className="max-w-4xl mx-auto text-center" data-id="element-143">
          <Lightbulb className="h-16 w-16 text-amber-400 mx-auto mb-6" data-id="element-144" />
          <h2 className="text-3xl font-bold mb-8" data-id="element-145">Fundamento terapéutico</h2>
          <p className="text-xl text-teal-100 mb-8 leading-relaxed" data-id="element-146">
            El inconsciente responde al lenguaje simbólico.
          </p>
          <p className="text-lg text-teal-50 mb-8 leading-relaxed" data-id="element-147">
            Las metáforas permiten bypass de defensas cognitivas, activación
            emocional correctiva y reorganización del significado interno.
          </p>
          <p className="text-2xl font-bold text-white mb-10" data-id="element-148">
            Por eso son uno de los recursos más potentes en terapia profunda.
          </p>
          <CTAButton variant="secondary" data-id="element-149">POTENCIAR MIS SESIONES</CTAButton>
        </div>
      </section>

      {/* Target Audience */}
      <section className="py-20 px-4 bg-white" data-id="element-150">
        <div className="max-w-4xl mx-auto" data-id="element-151">
          <div className="bg-slate-50 rounded-2xl p-8 md:p-12 border border-slate-200" data-id="element-152">
            <h2 className="text-3xl font-bold text-slate-900 mb-6 text-center" data-id="element-153">
              Para quién es
            </h2>
            <p className="text-lg text-slate-700 text-center mb-10" data-id="element-154">
              Profesionales que trabajen con procesos emocionales y quieran:
            </p>

            <div className="grid sm:grid-cols-2 gap-6" data-id="element-155">
              {['Profundizar intervenciones', 'Reducir estancamientos terapéuticos', 'Aumentar efectividad clínica', 'Optimizar carga emocional y cognitiva'].map((item, i) => <div key={i} className="bg-white p-4 rounded-lg shadow-sm border border-slate-100 flex items-center gap-3" data-id="element-156">
                  <div className="h-2 w-2 rounded-full bg-teal-500" data-id="element-157"></div>
                  <span className="font-medium text-slate-800" data-id="element-158">{item}</span>
                </div>)}
            </div>
          </div>
        </div>
      </section>

      {/* Testimonials */}
      <section className="py-20 px-4 bg-slate-100" data-id="element-159">
        <div className="max-w-6xl mx-auto" data-id="element-160">
          <h2 className="text-3xl font-bold text-center text-slate-900 mb-4" data-id="element-161">
            Lo que dicen los colegas
          </h2>
          <p className="text-center text-slate-600 mb-12 max-w-2xl mx-auto" data-id="element-162">
            Profesionales de toda Argentina ya están utilizando el Kit
            Terapéutico en sus consultas diarias.
          </p>

          <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6" data-id="element-163">
            {testimonials.map((t, i) => <div key={i} className={i >= 3 ? 'lg:col-span-1 md:col-span-1' : ''} data-id="element-164">
                <TestimonialCard {...t} data-id="element-165" />
              </div>)}
          </div>
        </div>
      </section>

      {/* Bonuses Section */}
      <section className="py-20 px-4 bg-white overflow-hidden" data-id="element-166">
        <div className="max-w-6xl mx-auto" data-id="element-167">
          <div className="text-center mb-16" data-id="element-168">
            <span className="bg-amber-100 text-amber-800 font-bold px-4 py-1 rounded-full text-sm uppercase tracking-wide mb-4 inline-block" data-id="element-169">
              Oferta Especial Limitada
            </span>
            <h2 className="text-3xl md:text-4xl font-bold text-slate-900 mb-4" data-id="element-170">
              Bonos Exclusivos de Regalo
            </h2>
            <p className="text-xl text-slate-600" data-id="element-171">
              Llevate estos 3 recursos complementarios{' '}
              <span className="font-bold text-teal-600" data-id="element-172">GRATIS</span> solo por
              hoy
            </p>
          </div>

          <div className="grid md:grid-cols-3 gap-8 mb-12" data-id="element-173">
            <BonusCard image="https://cdn.magicpatterns.com/uploads/wzADDChrMG4akmE8kbqh4f/aRoKPm3679820.webp" title="43 Recursos para la Ansiedad" description="Guía práctica con ejercicios inmediatos para crisis y regulación emocional." value="$8.500" data-id="element-174" />
            <BonusCard image="https://cdn.magicpatterns.com/uploads/idQ7LFTyzjbS1oirmgtZLj/BpLzlr9149110.webp" title="Mapa de Creencias Limitantes" description="Herramienta visual para detectar y desarticular patrones de pensamiento." value="$7.200" data-id="element-175" />
            <BonusCard image="https://cdn.magicpatterns.com/uploads/3wUMwPbUJth2Kufy8FCAHj/lYwPNp8899714.webp" title="Checklist de Diagnóstico" description="Protocolo rápido para evaluación inicial y seguimiento de pacientes." value="$6.800" data-id="element-176" />
          </div>
        </div>
      </section>

      {/* Guarantee Section */}
      <section className="py-16 px-4 bg-slate-50" data-id="element-177">
        <div className="max-w-3xl mx-auto bg-white border-2 border-teal-100 rounded-2xl p-8 md:p-12 text-center shadow-lg relative overflow-hidden" data-id="element-178">
          <div className="absolute top-0 right-0 -mt-4 -mr-4 bg-teal-500 text-white text-xs font-bold px-8 py-2 rotate-45 shadow-md" data-id="element-179">
            GARANTÍA
          </div>

          <ShieldCheck className="h-16 w-16 text-teal-500 mx-auto mb-6" data-id="element-180" />
          <h2 className="text-2xl font-bold text-slate-900 mb-4" data-id="element-181">
            Garantía de satisfacción – 7 días
          </h2>
          <p className="text-lg text-slate-700 mb-6" data-id="element-182">
            Usalo en sesiones reales durante 7 días.
          </p>
          <p className="text-slate-600 mb-6" data-id="element-183">
            Si no observás: <br data-id="element-184" />
            <span className="font-medium" data-id="element-185">
              • Mayor impacto • Más insight • Mejor dinámica de sesión
            </span>
          </p>
          <p className="font-bold text-slate-900 text-lg" data-id="element-186">
            Te devolvemos el 100%. Sin preguntas.
          </p>
        </div>
      </section>

      {/* Purchase Section */}
      <section id="purchase-section" className="py-20 px-4 bg-gradient-to-b from-slate-900 to-teal-900 text-white text-center" data-id="element-187">
        <div className="max-w-4xl mx-auto" data-id="element-188">
          <h2 className="text-3xl md:text-5xl font-bold mb-8" data-id="element-189">
            ACCESO INMEDIATO – 100% DIGITAL
          </h2>

          <div className="bg-white/10 backdrop-blur-md rounded-3xl p-8 md:p-12 border border-white/20 max-w-2xl mx-auto shadow-2xl" data-id="element-190">
            <h3 className="text-2xl font-bold text-amber-400 mb-2" data-id="element-191">
              KIT TERAPÉUTICO ESENCIAL
            </h3>
            <p className="text-teal-100 mb-8" data-id="element-192">+ 3 BONOS DE REGALO</p>

            <div className="flex flex-col items-center justify-center mb-8" data-id="element-193">
              <span className="text-slate-400 line-through text-xl mb-1" data-id="element-194">
                Precio regular: $42.500
              </span>
              <div className="flex items-start gap-1" data-id="element-195">
                <span className="text-2xl font-medium mt-2" data-id="element-196">$</span>
                <span className="text-6xl md:text-7xl font-bold text-white tracking-tight" data-id="element-197">
                  19.990
                </span>
                <span className="text-xl font-medium mt-2" data-id="element-198">ARS</span>
              </div>
            </div>

            <button onClick={handleDownloadClick} className="block w-full bg-amber-500 hover:bg-amber-600 text-white font-bold text-xl md:text-2xl py-6 px-8 rounded-xl shadow-lg hover:shadow-amber-500/30 transition-all duration-300 transform hover:-translate-y-1 mb-6 animate-pulse" data-id="element-199">
              DESCARGAR AHORA
            </button>

            <p className="text-sm text-slate-300 flex items-center justify-center gap-2" data-id="element-200">
              <Lock className="h-4 w-4" data-id="element-201" /> Pago 100% Seguro y Encriptado
            </p>

            <div className="mt-8 pt-8 border-t border-white/10 grid grid-cols-3 gap-4 opacity-70 grayscale hover:grayscale-0 transition-all" data-id="element-202">
              <div className="text-xs" data-id="element-203">Tarjeta de Crédito</div>
              <div className="text-xs" data-id="element-204">Tarjeta de Débito</div>
              <div className="text-xs" data-id="element-205">Mercado Pago</div>
            </div>
          </div>

          <p className="mt-12 text-slate-400 text-sm" data-id="element-206">
            👉 Tocá el botón y sumá a tu práctica el lenguaje que transforma
            procesos.
          </p>
        </div>
      </section>

      <footer className="bg-slate-950 text-slate-500 py-12 px-4 text-center text-sm" data-id="element-207">
        <div className="max-w-6xl mx-auto" data-id="element-208">
          <p className="mb-4" data-id="element-209">
            © {new Date().getFullYear()} Recursos Profesionales. Todos los
            derechos reservados.
          </p>
          <p data-id="element-210">
            Este producto no sustituye la formación profesional ni el juicio
            clínico.
          </p>
        </div>
      </footer>
    </div>;
}